import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=237e5be7&scoped=true&lang=pug&"
import script from "./CopyLink.vue?vue&type=script&lang=js&"
export * from "./CopyLink.vue?vue&type=script&lang=js&"
import style0 from "./CopyLink.vue?vue&type=style&index=0&id=237e5be7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e5be7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
